app.config([
  '$translateProvider',
  function ($translateProvider) {
    $translateProvider.translations("ms", {
        "AC": "Ascension Island",
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AX": "Åland Islands",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BQ": "Caribbean Netherlands",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BV": "Bouvet Island",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos [Keeling] Islands",
        "CD": "Congo [DRC]",
        "CF": "Central African Republic",
        "CG": "Congo [Republic]",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CP": "Clipperton Island",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curaçao",
        "CX": "Christmas Island",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DG": "Diego Garcia",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EA": "Ceuta and Melilla",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "EU": "European Union",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands [Islas Malvinas]",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "French Guiana",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadeloupe",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GS": "South Georgia and the South Sandwich Islands",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HM": "Heard Island and McDonald Islands",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "IC": "Canary Islands",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar [Burma]",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn Islands",
        "PR": "Puerto Rico",
        "PS": "Palestinian Territories",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "QO": "Outlying Oceania",
        "RE": "Réunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "São Tomé and Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TA": "Tristan da Cunha",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TF": "French Southern Territories",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "UM": "U.S. Outlying Islands",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican City",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "ZZ": "Unknown Region",
        "action.add_photo": "Muat Naik Gambar",
        "action.load_earlier": "Muatkan Sebelum",
        "action.load_more": "Muatkan Seterusnya",
        "action.send": "Hantar",
        "address.fields.address": "Alamat",
        "address.fields.address.city": "Bandar",
        "address.fields.address.country": "Negara",
        "address.fields.address.postcode": "Poskod (jika berkenaan)",
        "address.fields.address.recipient_name": "Nama Penerima",
        "address.fields.address.remarks": "Ringkasan",
        "address.fields.address.state": "Daerah/Negeri/Wilayah",
        "address.fields.city": "Bandar",
        "address.fields.country": "Negara",
        "address.fields.postcode": "Poskod",
        "address.fields.recipient_name": "Nama Penerima",
        "attachment.upload.description": "File must be less than 2MB \nAllowed fil types: pdf, doc, docx, xls, xlsx, csv, jpg, jpeg, png, gif",
        "back": "Back",
        "back_in_stock.added": "In Stock Notification On",
        "back_in_stock.avaiable": "Notify When in Stock",
        "back_in_stock.subscibe.success.message": "When product is back in stock, we will send you a notification.",
        "back_member_center": "Back to Member Center",
        "birthday_picker.date.placeholder": "Date",
        "birthday_picker.month.placeholder": "Month",
        "birthday_picker.year.placeholder": "Year",
        "cart": "Troli Membeli-belah",
        "cart.affiliate_code.apply_success": "Affiliate Applied",
        "cart.checkout": "Semak keluar",
        "cart.clean": "Checkout now!",
        "cart.copy.info.affiliate_code": "Affiliate code ({{code}}), ",
        "cart.copy.info.copied": "Website address copied:",
        "cart.copy.info.product_count": "{{count}} products",
        "cart.coupon_code.apply_success": "Coupon Applied",
        "cart.empty": "Troli anda kosong.",
        "cart.empty.continue": "Teruskan membeli-belah sekarang!",
        "cart.empty.description": "Tambah produk ke troli untuk meneruskan.",
        "cart.item.remove": "Keluarkan",
        "cart.items.remove": "Keluarkan",
        "cart.lock_cart_sc_product.description": "This product was ordered from a livestream/ Post Sales, its quantity is fixed.",
        "cart.lock_cart_sc_product.remove_hint": "This product was ordered from a livestream/ Post Sales, it cannot be deleted",
        "cart.over_limit": "The shopping cart exceeds the maximum number of <span class=\"limit-number\">{{limit_number}}</span> items, please checkout before adding new items. You may also log in to add these items to your wishlist!",
        "cart.over_limit.login": "The shopping cart exceeds the maximum number of <span class=\"limit-number\">{{limit_number}}</span> items, please checkout before adding new items. You may also add this item to your wishlist!",
        "cart.promotion.bundle_group.has_items_selected": "Group A <b style=\"color: #f05c53\">{{red_quantity}}</b> items selected{{red_reminder}}; Group B <b style=\"color: #1ba462\">{{green_quantity}}</b> items selected{{green_reminder}}{{applied_reminder}}",
        "cart.promotion.bundle_group.has_items_selected.mobile": "Group A <b style=\"color: #f05c53\">{{red_quantity}}</b> items; Group B <b style=\"color: #1ba462\">{{green_quantity}}</b> items",
        "cart.promotion.checkout": "Checkout",
        "cart.promotion.has_items_selected": "<b>{{quantity}}</b> items selected",
        "cart.promotion_reminder.amount": "Buy {{gap}} more ",
        "cart.promotion_reminder.applied.discount": "Enjoy the offer, ",
        "cart.promotion_reminder.applied.discount_prefix": ". ",
        "cart.promotion_reminder.applied.free_shipping": "Enjoy free shipping. ",
        "cart.promotion_reminder.applied.gift": "Enjoy free gift. ",
        "cart.promotion_reminder.applied.reward_campaign": "Enjoy the offer, ",
        "cart.promotion_reminder.applied_highest.discount": "Enjoy the offer!",
        "cart.promotion_reminder.applied_highest.free_shipping": "Enjoy free shipping!",
        "cart.promotion_reminder.applied_highest.gift": "Enjoy free gift!",
        "cart.promotion_reminder.applied_highest.reward_campaign": "Enjoy the offer!",
        "cart.promotion_reminder.discount_target.discount": "to get the offer!",
        "cart.promotion_reminder.discount_target.free_shipping": "to enjoy free shipping!",
        "cart.promotion_reminder.discount_target.gift": "to get free gift!",
        "cart.promotion_reminder.discount_target.reward_campaign": "to get the offer!",
        "cart.promotion_reminder.group_gap": " ({{gap}} more to go)",
        "cart.promotion_reminder.group_green": "<span class=\"bundle-group-label bundle-group-green\">Group B </span> {{gap}} more to go",
        "cart.promotion_reminder.group_red": "<span class=\"bundle-group-label bundle-group-red\">Group A </span> {{gap}} more to go",
        "cart.promotion_reminder.item": "Buy {{gap}} more ",
        "cart.promotion_reminder.multiple_step": "to save more!",
        "cart.promotion_reminder.multiple_step.reward_campaign": "to save more!",
        "cart.promotion_reminder.separator": ". ",
        "cart.promotion_reminder.stackable": "Buy more to save more!",
        "cart.redeem_gift.has_items_selected": "<span>{{total_point}}</span> points used, <span>{{rest_point}}</span> points left",
        "cart.redeem_gift.has_items_selected.insufficient_point": "Exceed <span>{{rest_point}}</span> points, please remove some gifts.",
        "cart.related_products.title": "You might also like...",
        "cart.share.btn.tooltip": "Copy shopping cart items to friends",
        "cart.title": "Troli Membeli-belah",
        "checkout.auto_fill.popup.cancel": "Cancel",
        "checkout.auto_fill.popup.continue": "Continue",
        "checkout.auto_fill.popup.error": "Please enter the correct format",
        "checkout.auto_fill.popup.title": "Enter your phone for fast checkout",
        "checkout.auto_fill.toast.error": "If there is no record of the last order detected, the fast checkout data will not be brought in",
        "checkout.card_info_error": "Please verify the information and try again.",
        "checkout.card_type_not_support_error": "The card type is not supported at this moment",
        "checkout.cart_over_limit_error": "The maximum number of items is 100, please adjust the quantity and purchase again",
        "checkout.delivery_option.out_of_stock": "Some products are out of stock, this store cannot be selected, please try another store.",
        "checkout.delivery_option.title": "Alamat Penghantaran",
        "checkout.discount.applied_coupons": "Kupon Digunakan",
        "checkout.discount.applied_promotions": "Promosi Digunakan",
        "checkout.fields.add_new": "Tambah baru...",
        "checkout.fields.delivery_method": "Kaedah Penghantaran",
        "checkout.fields.email": "E-mel Pelanggan",
        "checkout.fields.email.hint": "Sila isikan alamat e-mel anda dengan tepat supaya mesej pengesahan pesanan dapat dihantarkan kepada anda.",
        "checkout.fields.email.placeholder": "Alamat E-mel",
        "checkout.fields.out_of_stock": "Maaf, stok tidak mencukupi. Sila keluarkannya daripada troli dan semak keluar semula.",
        "checkout.fields.phone": "Nombor telefon",
        "checkout.fields.phone.hint": "Sila isikan nombor telefon bimbit anda untuk menerima perkembangan status penghantaran melalui SMS,",
        "checkout.fields.phone.invali": "",
        "checkout.fields.phone.invalid": "Nombor telefon tidak sah",
        "checkout.fields.phone.placeholder": "Masukkan nombor telefon anda",
        "checkout.fields.remarks": "Ringkasan untuk Kedai",
        "checkout.fields.remarks.placeholder": "Tinggalkan ringkasan pesanan untuk peniaga",
        "checkout.fields.select": "Pilih satu...",
        "checkout.instalment_amount": "Kira-kira {{amount}} x {{period}} bayaran ansuran",
        "checkout.instructions": "Maklumat pesanan",
        "checkout.labels.promotion.coupon": "Kupon",
        "checkout.labels.promotion.free_shipping": "Penghantaran percuma",
        "checkout.labels.promotion.membership": "Promosi ahli",
        "checkout.labels.promotion.promotion": "Promosi",
        "checkout.payment_condition.continue_shopping": "Continue Shopping",
        "checkout.payment_condition.description": "Before proceeding to checkout, please return to the shopping cart to choose another payment method or continue shopping",
        "checkout.payment_condition.hint": "This order must meet the minimum amount in order to proceed to checkout",
        "checkout.payment_condition.title": "Still need {{difference}} to meet the checkout conditions!",
        "checkout.payment_failed": "Transaksi ini gagal. Sila cuba semula.",
        "checkout.payment_failed.atome.minamount": "The order amount does not meet the payment method minimum, please modify the content of the shopping cart or switch to another payment method. ",
        "checkout.payment_failed.check_credit_card_info": "Please make sure you provided the correct information of your credit card, or you may contact with merchants or card issuing banks.",
        "checkout.payment_method.title": "Pembayaran",
        "checkout.payments.apple_pay.not_supported": "Perkhidmatan Apple Pay tidak disokong oleh peranti ini, sila lihat <ul><li>Sila daftar masuk ke pelayar internet menerusi akaun Apple anda</li><li>Sila TAMBAH kaedah pembayaran tersebut ke Akaun Apple Pay anda</li><li>Sila NAIK TARAF peranti ini serta pelayar internet anda ke versi yang terbaru</li></ul>",
        "checkout.payments.exist.order.tip": "You have already placed order <a href=\"{{ duplicateOrderLink }}\">{ {{order}} }</a>. If you wish to complete the checkout, please click “Place Order”.",
        "checkout.payments.google_pay.not_supported": "Perkhidmatan Google Pay tidak disokong oleh peranti ini, sila lihat <ul><li>Sila daftar masuk ke pelayar internet menerusi akaun Google anda</li><li>Sila TAMBAH kaedah pembayaran tersebut ke Akaun Google Pay anda</li><li>Sila NAIK TARAF peranti ini serta pelayar internet anda ke versi yang terbaru</li></ul>",
        "checkout.payments_transaction_error": "There is some issue with your order. Please check the payment information again or contact your card’s issuing bank directly.",
        "checkout.promotion.tags.coupon": "Kupon",
        "checkout.promotion.tags.free_shipping": "Penghantaran Percuma",
        "checkout.promotion.tags.membership": "Tawaran Ahli",
        "checkout.promotion.tags.promotion": "Promosi",
        "checkout.promotion.tags.subscription_promotion": "Product Subscription Promotion",
        "checkout.recipient_name_invalid": "Invalid recipient name. Please enter up to 10 characters without spaces or special characters.",
        "checkout.recipient_phone_invalid": "Recipient Phone Number is incorrect, please check again.",
        "checkout.station_space_confirm_error": "Failed to select pickup store, please try again or contact us",
        "checkout.store_unavailable": "Store unavailable. Please choose another.",
        "checkout.timeout": "There is an issue with your payment. If you place an order again, there may be a repeat order. Please contact us to check on the payment status.",
        "checkout_object.detail.close": "Close",
        "checkout_object.detail.title": "Checkout Amount Detail",
        "close": "Close",
        "cookie_consent_popup.buttons.accept": "Accept",
        "cookie_consent_popup.buttons.save_preferences": "Save Preferences",
        "cookie_consent_popup.buttons.settings": "Settings",
        "cookie_consent_popup.claim.description": "Hi, this website uses essential cookie to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only upon approval.",
        "cookie_consent_popup.claim.heading": "We use cookies",
        "cookie_consent_popup.claim.read_more": "Read more",
        "cookie_consent_popup.cookie_descriptions.functionality": "These cookies allow a website to remember choices you have made in the past, like what language you prefer, or what currency you prefer.",
        "cookie_consent_popup.cookie_descriptions.marketing": "These cookies collect your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad. These cookies can share that information with other organizations or advertisers. These are persistent cookies and almost always of third-party provenance.",
        "cookie_consent_popup.cookie_descriptions.necessary": "These cookies are required to enable core website functionality and are automatically enabled when you use the site. These include cookies that help to make the shopping cart and checkout process possible, as well as assisting in security issues and conforming to regulations.",
        "cookie_consent_popup.cookie_descriptions.statistical": "These cookies collect information on how you use the website, for instance which pages you visit most often or if you got any error message. The information collected by these cookies is aggregated and therefore anonymous. We use them for advertising measurement and to improve how the website works.",
        "cookie_consent_popup.cookie_names.functionality": "Functionality cookies",
        "cookie_consent_popup.cookie_names.marketing": "Marketing cookies",
        "cookie_consent_popup.cookie_names.necessary": "Strictly necessary cookies",
        "cookie_consent_popup.cookie_names.statistical": "Statistical cookies",
        "coupon.already_taken": "You have already got this coupon",
        "coupon.back_to_cart_button": "Checkout",
        "coupon.close": "Close",
        "coupon.comingSoon": "Coming Soon",
        "coupon.confirm": "Confirm",
        "coupon.congratulation": "Coupon claimed",
        "coupon.expired": "Expired",
        "coupon.first_purchase_only": "1st Order",
        "coupon.first_purchase_only.with_platform": "1st Purchase Only in {{platform}}",
        "coupon.first_shoppers": "First {{number}} Shoppers Only",
        "coupon.invalid": "Invalid",
        "coupon.is_expired": "Coupon expired",
        "coupon.login": "Login",
        "coupon.login_or_register": "Please click the button to login or register",
        "coupon.login_to_receive": "Login to receive coupon",
        "coupon.no_available_coupon": "No Available Coupon",
        "coupon.no_comingSoon_coupon": "No Coming Soon Coupon",
        "coupon.no_invalid_coupon": "No Invalid Coupon",
        "coupon.no_valid_coupon": "No Valid Coupon",
        "coupon.not_eligible": "Not eligible for coupon",
        "coupon.one_time": "One-Time",
        "coupon.online_and_selected_retail_store_only": "Online Store/Selected Retail Store Only",
        "coupon.online_store_only": "Online Store Only",
        "coupon.only_tag": "Only",
        "coupon.reach_limit": "Reach limit",
        "coupon.retail_store_only": "Retail Store Only",
        "coupon.select_coupon": "Select Coupon",
        "coupon.selected_retail_store_list": "List of Selected Retail Store",
        "coupon.selected_retail_store_only": "Selected Retail Store Only",
        "coupon.start_at": "Begins on <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">Display in your time zone<br/>(GMT{{timeZone}})</div> {{time}} </span>",
        "coupon.success": "Success",
        "coupon.title": "Coupon",
        "coupon.unfit_first_purchase": "Coupon is only for the first purchase order",
        "coupon.usage_limit": "All coupons have been claimed",
        "coupon.used": "Used",
        "coupon.valid": "Valid",
        "coupon.valid_until": "Ends on <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">Display in your time zone<br/>(GMT{{timeZone}})</div> {{time}} </span>",
        "coupon.view": "View Coupons",
        "coupon_center": "Coupon Center",
        "coupon_center.empty": "没有可领取的优惠券",
        "coupon_input.claim": "Claim",
        "coupon_input.claim_failed": "Failed to claim",
        "coupon_input.claim_succeed": "Congratulations on getting {{ couponName }} coupon.",
        "coupon_input.claim_succeed.redirect": "Congratulations on getting {{ couponName }} coupon. View it in the member center!",
        "coupon_input.placeholder": "Enter coupon code",
        "coupon_v2.claim": "Claim now",
        "coupon_v2.claim.success": "Congratulations on getting {{ name }} coupon",
        "coupon_v2.claimed": "Claimed",
        "coupon_v2.copy_code": "Copy Code",
        "coupon_v2.copy_code.success": "Code Copied",
        "coupon_v2.discount_type.discount": "Discount",
        "coupon_v2.discount_type.free_shipping": "Free Shipping",
        "coupon_v2.discount_type.gift": "Free Gift",
        "coupon_v2.first_purchase_only": "For 1st purchase only",
        "coupon_v2.first_purchase_with_platform": "For 1st {{platform}} purchase only",
        "coupon_v2.login_to_claim": "Log in to claim",
        "coupon_v2.no_quota": "All claimed",
        "coupon_v2.period.end_at": "End at {{ date }}",
        "coupon_v2.period.start_at": "Start at {{ date }}",
        "coupon_v2.use": "Use",
        "delivery.sfexpress.district": "Daerah SF Ekspres",
        "delivery.sfexpress.ef_locker": "EF Locker",
        "delivery.sfexpress.locker_location": "Locker Location",
        "delivery.sfexpress.store": "Lokasi SF Ekspres",
        "delivery_address.district.hk": "Daerah",
        "delivery_address.district.th": "District",
        "delivery_address.district.tw": "Daerah",
        "delivery_address.district.vn": "District",
        "delivery_address.province.th": "Province",
        "delivery_address.province.vn": "Province",
        "delivery_address.region.hk": "Rantau",
        "delivery_address.region.tw": "Negeri/Bandar",
        "delivery_address.store": "{{ station_name }} Store",
        "delivery_address.street": "Road/Street",
        "delivery_address.ward.th": "Sub-district",
        "delivery_address.ward.vn": "Ward",
        "delivery_fee.pay.on.delivery": "You will be charged for shipping when the goods arrive.",
        "delivery_options.fields.delivery_type": "Jenis Penghantaran",
        "delivery_options.fields.delivery_types.custom": "Khas",
        "delivery_options.fields.delivery_types.email": "E-mel",
        "delivery_options.fields.delivery_types.international": "Antarabangsa",
        "delivery_options.fields.delivery_types.local": "Tempatan",
        "delivery_options.fields.delivery_types.pickup": "Pungutan",
        "delivery_options.fields.delivery_types.tw_simple_711": "Pungutan 7-11 (TW sahaja)",
        "delivery_options.fields.delivery_types.tw_simple_familymart": "Pungutan Family Mart (TW sahaja)",
        "delivery_options.fields.select_date": "Tarikh Ketibaan",
        "dropdown.hint": "Sila pilih",
        "dynamic.delivery.fee.calculate.desc": "Kadar penghantaran untuk 1 kg pertama + (jumlah berat-1kg) * kadar tambahan berat penghantaran",
        "dynamic.delivery.fee.calculate.hint": "Sekiranya jumlah berat adalah kurang dari 1 kg, ia akan dikira sebagai 1 kg",
        "dynamic.delivery.fee.calculate.info": "jumlah penghantaran adalah: {{totalDeliveryFee}}",
        "dynamic.delivery.fee.calculate.title": "Kaedah pengiraan kadar penghantaran",
        "dynamic.delivery.fee.no.state.info": "Kadar penghantaran akan dipaparkan setelah alamat penghantaran disahkan",
        "dynamic.delivery.fee.no.state.notice": "Kadar penghantaran akan dipaparkan di laman daftar keluar setelah alamat penghantaran diisikan.",
        "dynamic.delivery.fee.updated.notice": "Kadar penghantaran telah dikemaskini",
        "error.401.description": "Anda tidak dibenarkan mengakses halaman ini",
        "error.401.title": "Kami minta maaf",
        "error.403.description": "Anda tidak dibenarkan mengakses halaman ini",
        "error.403.not_signed_in.anchor": "daftar masuk",
        "error.403.not_signed_in.message": "kemungkinan sebab anda belum",
        "error.403.title": "Kami minta maaf",
        "error.404.description": "Halaman ini tidak wujud",
        "error.404.title": "Kami minta maaf",
        "error.continue": "Teruskan membeli-belah sekarang!",
        "ezship.error.account_not_exist": "Akaun ezShip tidak wujud. Sila hubungi peniaga",
        "ezship.error.invalid_amount": "Amaun tidak sah. Amaun maksimum menggunakan ezShip adalah TWD 6000 untuk setiap pesanan.",
        "ezship.error.invalid_email": "E-mel tidak sah",
        "ezship.error.invalid_input": "Satu atau lebih maklumat tidak betul atau tidak lengkap",
        "ezship.error.invalid_mobile": "Nombor telefon tidak sah",
        "ezship.error.invalid_name": "Nama penerima tidak sah",
        "ezship.error.invalid_store": "Kedai Pungutan tidak sah",
        "ezship.error.no_easybag": "Akaun ezShip tidak mempunyai Easybag atau Minibag buat masa ini",
        "ezship.error.no_permission": "Akaun ezShip tidak mempunyai tahap kebenaran yang mencukupi",
        "ezship.error.system_error": "Ralat sistem ezShip: Sila pilih kaedah penghantaran yang lain atau cuba sebentar lagi.",
        "facebook_banner.description": "You’re visiting the website on Facebook in-app browser, please use another browser if you encounter upload image issue. <span>Copy Link</span>",
        "facebook_messenger_checkbox.subscribe": "Send to Messenger",
        "facebook_messenger_checkbox.subscribed": "Dihantar ke {{topic}} melalui",
        "facebook_messenger_checkbox.topics.MARKETING": "berita dan promosi terbaru kedai",
        "facebook_messenger_checkbox.topics.ORDER_STATUS_UPDATE,DELIVERY_STATUS_UPDATE": "notifikasi perkembangan pesanan",
        "facebook_messenger_checkbox.turn_off": "Matikan",
        "facebook_messenger_checkbox.v2.subscribe": "Send to Messenger",
        "facebook_messenger_checkbox.v2.subscribed": "Send via Facebook",
        "fb_in_app_browser_popup.copy_link": "Copy Link.",
        "fb_in_app_browser_popup.desc": "You’re visiting the website via built-in browser of Facebook app, please use another browser in case of any failure during checkout. ",
        "form.action.delete": "Padam",
        "form.response.load.more.error": "Unable to load the data, please try again.",
        "form.validation.birthday.invalid": "Birthday is invalid",
        "form.validation.birthday.invalid.minimum_age_limit": "Birthday is invalid, should over {{minimumAgeLimit}} years old.",
        "form.validation.birthday.required": "Birthday is required",
        "form.validation.calling_code": "Country calling code is required",
        "form.validation.card.bin.error": "Current payment method is not applicable to your credit card. Please contact shop owner for details.",
        "form.validation.card.bin.error.unknow_scheme": "We cannot identify your credit card type. Please email shop owner for details.",
        "form.validation.confirmation": "Kata laluan tidak sepadan.",
        "form.validation.delivery_option.country": "Jenis penghantaran yang anda pilih tidak tersedia untuk negara ini. Sila ubah alamat penghantaran anda atau pilih kaedah penghantaran yang lain.",
        "form.validation.delivery_option.cross_border.MY": "The delivery type you have chosen is not available for {{ area == \"west\" ? \"West\" : \"East\" }} Malaysia, please change your delivery address or choose another delivery method",
        "form.validation.delivery_option.local": "Jenis penghantaran yang anda pilih tidak tersedia untuk pulau-pulau di Taiwan. Sila ubah alamat penghantaran anda atau pilih kaedah penghantaran yang lain.",
        "form.validation.delivery_option.outlying": "Jenis penghantaran yang anda pilih tidak tersedia untuk pulau-pulau pedalaman di Taiwan. Sila ubah alamat penghantaran anda atau pilih kaedah penghantaran yang lain.",
        "form.validation.delivery_option.region": "Jenis penghantaran yang anda pilih tidak tersedia untuk rantau ini. Sila ubah alamat penghantaran anda atau pilih kaedah penghantaran yang lain.",
        "form.validation.email": "{{field_name}} tidak sah",
        "form.validation.email.duplicate": "Email is taken. Please enter another email.",
        "form.validation.email.hint": "Please enter a valid email address.",
        "form.validation.id_no": "Reminder: Without the recipient's identity id, the import declaration might be affected.",
        "form.validation.invalid": "{{field_name}} tidak sah",
        "form.validation.maxlength": "{{field_name}} terlalu panjang",
        "form.validation.maxlength.with.number": "{{field_name}} is up to {{max_length}} characters",
        "form.validation.minlength": "{{field_name}} terlalu pendek",
        "form.validation.mobile.error": "{{field_name}} is incorrect, please enter mobile phone",
        "form.validation.passport": "Reminder: Without the recipient's passpport number, the import declaration might be affected.",
        "form.validation.pattern": "{{field_name}} tidak sah",
        "form.validation.pattern.711_cross_border.delivery_address": "Please write in English for cross-border delivery services.",
        "form.validation.pattern.customer_name.user_name_invalid": "Invalid name: The input contains unsupported symbols.",
        "form.validation.pattern.recipient-name": "Tidak dibenarkan menggunakan ruang dan simbol atau melebihi {{limit_length}} aksara.",
        "form.validation.pattern.recipient-phone.TW": "{{field_name}} mesti masukkan 10 nombor digit",
        "form.validation.pattern.recipient-phone.above_size": "Recipient contact number must input more than {{ max_count }} digits numbers",
        "form.validation.pattern.recipient-phone.beginning_stint": "Recipient Contact Number must start with {{ stint_charts.split(\",\").join(\" or \") }}",
        "form.validation.pattern.recipient-phone.fix_size": "Recipient Contact Number must input {{ max_count }} digits numbers",
        "form.validation.phone.error": "{{field_name}} is incorrect, please check again",
        "form.validation.phone.required": "{{field_name}} is required",
        "form.validation.policy": "Anda mesti bersetuju dengan terma dan syarat untuk meneruskan.",
        "form.validation.required": "{{field_name}} diperlukan",
        "form.validation.unique": "{{field_name}} sudah digunakan. Sila pilih semula.",
        "gift.exceed.limit": "Exceed gift purchase limit, please adjust your quantity.",
        "gift.items_needed.hint": "<span class=\"highlight-label\">{{ quantity }}</span> more product(s) to complete the selection",
        "gift.quantity_label.unqualified": "{{ quantity }} item(s) needed",
        "gift.sold_out": "The gift you selected is out of stock.",
        "gift.variation.confirm": "Confirm",
        "go_coupon_center": "Go to Coupon Center",
        "hk_sfplus.address": "{{region}}, {{district}}, {{area}}",
        "hk_sfplus.area": "Kawasan",
        "hk_sfplus.district": "Daerah",
        "hk_sfplus.region": "Rantau",
        "imagepicker.title": "Muat Naik Imej",
        "in_app_browser_popup.desc": "To log in and check out with a better shopping experience, we recommend you open the default browser.",
        "languages.en": "English",
        "languages.id": "bahasa Indonesia",
        "languages.jp": "日本語",
        "languages.vi": "",
        "languages.zh-hant": "中文",
        "line_messenger_checkbox.button.unsubscribe": "Turn off",
        "line_messenger_checkbox.order_notification.subscribed": "Sent this order update notifications via",
        "line_messenger_checkbox.subscribe": "Send to LINE",
        "line_messenger_checkbox.subscribed": "Sent via LINE",
        "lock_inventory.locked_quantity_unit": "piece(s)",
        "lock_inventory.tooltip": "Reserve till {{expired_time}} \n(Live streamed at {{start_time}} :{{event_name}})\n Display according to your local time zone (GMT {{timezone}})",
        "media.validation.error": "Ralat memuat naik imej",
        "media.validation.error.file_attachment_size": "Please upload file less than 2MB.",
        "media.validation.error.file_size": "Please upload the image less than 5MB.",
        "media.validation.file_limit.one": "You may only upload up to 1 files",
        "media.validation.type": "hanya format jpeg dan png dibenarkan",
        "member.center.load.more": "Seterusnya",
        "member.center.load.more.error": "Tidak dapat memuat data, sila cuba lagi.",
        "member_point": "points",
        "member_points.display.expire_point": "points will expire on",
        "member_points.display.successive_expire_point": "points will expire in succession after",
        "member_points.earn_from_order_description": "",
        "member_points.equal_cash": "Equal to {{money}}",
        "member_points.fields.auto_reward": "Points rewarded from order",
        "member_points.fields.auto_reward_seconds": "",
        "member_points.fields.date": "Date",
        "member_points.fields.expire": "",
        "member_points.fields.expired": "Point Expired",
        "member_points.fields.expiry_date": "Expiry Date",
        "member_points.fields.member_info_reward": "Member Profile Completion Reward Member Points",
        "member_points.fields.member_point_expired": "Point Expired",
        "member_points.fields.product_review_reward": "Completed review for order <a href=\"{{link}}\">{{ orderNumber }}</a>",
        "member_points.fields.remarks": "Point Change Reason",
        "member_points.fields.revert_member_point": "Points reverted from cancelled order",
        "member_points.fields.revert_member_point.order_edit": "Points reverted from edited order",
        "member_points.fields.revert_member_point.order_split": "Points reverted from split order",
        "member_points.fields.revert_member_point.return": "Points reverted from returned order",
        "member_points.fields.revert_member_point.return_order_revert": "Reverted points; from return",
        "member_points.fields.successive_expire": "",
        "member_points.fields.value": "Point Movement",
        "member_points.no_data": "No point records",
        "member_points.point_balance": "Point Balance",
        "member_points.point_history": "Point History",
        "member_points.redeem_cash_and_earn_from_order_description": "",
        "member_points.redeem_cash_description": "",
        "member_points.rule": "Points Rules",
        "member_points.title": "Member Points",
        "member_points.unit": "Point",
        "member_referral.code.copy_and_share": "Share the link with your friend, you both get store credits.",
        "member_referral.code.remarks": "Campaign Rules",
        "member_referral.copy.link": "Copy Link",
        "member_referral.copy.link.success": "Link Copied",
        "member_referral.discount": "Member Referral Campaign",
        "member_referral.generate.code": "Generate referral link",
        "member_referral.generate.code.success": "Referral link generated",
        "member_referral.rules": "Campaign Rules",
        "member_referral.welcome_credit.popup.content": "You've earned  {{reward_value}} credits. You can refer your friends to earn more credits.",
        "member_referral.welcome_credit.popup.continue": "Shop Now",
        "member_referral.welcome_credit.popup.title": "Congratulation, You've earned {{reward_value}} credits",
        "membership.profile.check.code.error": "Kod pemeriksaan tidak betul! Sila masukkannya semula atau hantar semula sms kod pemeriksaan",
        "membership.profile.email_subscription.error": "To subscribe to Email, please enter an email address and try again.",
        "membership.profile.mobile.number.verified": "Nombor telefon bimbit telah disahkan dan akan menggantikan nombor telefon yang anda simpan sebelum ini.",
        "membership.profile.sms_subscription.error": "To subscribe to SMS, please enter an mobile phone and try again.",
        "membership.profile.subscriptions.marketing.news": "Berita dan promosi terbaru kedai",
        "membership.profile.subscriptions.messages.new": "Mesej baharu daripada peniaga",
        "membership.profile.subscriptions.none": "Tiada",
        "membership.profile.subscriptions.orders.comments.new": "Komen baharu daripada peniaga tentang pesanan saya",
        "membership.profile.subscriptions.orders.update.status": "Kemas kini untuk pesanan saya",
        "membership.profile.verification_hint": "If you change email address, verification is required after save. Email will be updated to {{unconfirmed_email}} after verification is completed.",
        "messages.form.send": "Hantar",
        "model.credit_card.choose_card": "Fast checkout with your saved card",
        "model.credit_card.subtitle": "Sila masukkan kad kredit anda di bawah untuk mengemas kini",
        "model.credit_card.title": "Maklumat Kad Kredit Anda",
        "model.credit_card.use_new_card": "Use a new card",
        "model.slpayment.recurring_pay_agreement": "We’ll use the payment details you just provided for subsequent recurrent payments. By submitting, you agree to the <a href=\"https://shopline.tw/about/product_subscription_agreements_en\" target=\"_blank\" rel=\"noopener\">Term Purchase bank card Withholding Agreement.</a>",
        "model.slpayment.security_agreement": "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
        "model.update_credit_card_for_product_subscription.fail": "The payment information for Product Subscription is invalid. Please try again.",
        "model.update_credit_card_for_product_subscription.success": "Credit card information updated successfully",
        "multi_checkout.add_new_store": "Add new store",
        "multi_checkout.cart_tag_unnamed": "(unnamed)",
        "multi_checkout.change.payment_type.modal.cancel": "Cancel",
        "multi_checkout.change.payment_type.modal.confirm": "Update",
        "multi_checkout.change.payment_type.modal.description": "You will need to reselect delivery method and fill out shipping information again once you change the payment type.",
        "multi_checkout.change.payment_type.modal.title": "You are About to Change Payment Type",
        "multi_checkout.checkout.delivery_time.description": "Description of Delivery Time:",
        "multi_checkout.checkout.destination.title": "Destination Information",
        "multi_checkout.default_store": "Default store",
        "multi_checkout.delivery_attribute": "order",
        "multi_checkout.delivery_section.cod": "Cash on Delivery",
        "multi_checkout.delivery_section.collapse.hint": "Expand",
        "multi_checkout.delivery_section.country.label": "Country/Region",
        "multi_checkout.delivery_section.delivery_option.label": "Delivery Options",
        "multi_checkout.delivery_section.empty_delivery_methods": "No Matched Option",
        "multi_checkout.delivery_section.ncod": "Non Cash on Delivery",
        "multi_checkout.delivery_section.payment_type.label": "Payment Type",
        "multi_checkout.delivery_section.title": "Select Payment Type and Delivery Method",
        "multi_checkout.destination_section.address_type.new": "New address",
        "multi_checkout.destination_section.delivery_type.label": "Selected Delivery Method:",
        "multi_checkout.destination_section.dynamic_fee.hint": "The freight will be displayed after filling in address",
        "multi_checkout.destination_section.pick_store.label": "Find a store",
        "multi_checkout.destination_section.pick_store.store_address": "Address",
        "multi_checkout.destination_section.pick_store.store_code": "Selected Store Code",
        "multi_checkout.destination_section.pick_store.store_name": "Selected Store Name",
        "multi_checkout.destination_section.title": "Destination Information",
        "multi_checkout.items.title": "Shopping Cart",
        "multi_checkout.next_step": "Next",
        "multi_checkout.promotions.title": "discount",
        "multi_checkout.summary_section.check_payment_instructions": "Check Payment Instructions",
        "multi_checkout.summary_section.confirm": "Confirm",
        "multi_checkout.summary_section.delivery_type.label": "Delivery Method",
        "multi_checkout.summary_section.expand_payment_instructions": "Expand",
        "multi_checkout.summary_section.title": "Order details",
        "order": "Pesanan",
        "order.billing_address.same": "Sama seperti alamat penghantaran",
        "order.billing_address.title": "Billing Address",
        "order.customer_email": "Alamat e-mel pelanggan",
        "order.customer_name": "Nama pelanggan",
        "order.customer_phone": "Nombor telefon pelanggan",
        "order.delivery_address.address_1": "Alamat",
        "order.delivery_address.city": "Bandar",
        "order.delivery_address.postcode": "Postcode",
        "order.delivery_address.state": "Daerah/Negeri/Wilayah",
        "order.delivery_data.consignee_id_no": "Recipient ID Number or Passport Number",
        "order.delivery_data.location_code": "Kod Kedai",
        "order.delivery_data.location_name": "Nama Kedai",
        "order.delivery_data.recipient_name": "Nama penerima",
        "order.delivery_data.recipient_phone": "Nombor telefon penerima",
        "order.delivery_data.scheduled_delivery_date": "Tarikh Ketibaan",
        "order.delivery_data.time_slot": "Masa Penghantaran",
        "order.delivery_data.time_slot_key": "Slot Masa Ketibaan",
        "order.email": "Alamat e-mel",
        "order.invoice.carrier_number": "Nombor Plat Kenderaa",
        "order.invoice.mailing_address": "Alamat",
        "order.invoice.tax_id": "ID Cukai",
        "order.payment_data.credit_card_number": "Nombor Kad Kredit",
        "order.payment_data.cvc": "CVC",
        "order.payment_data.expiry_date": "Tarikh Luput",
        "order.payment_data.holdername": "Nama Penuh Pemegang Kad",
        "order.payments.login.confirm": "Please log in and go to pay again or update credit card information!",
        "order_comment_and_message.general_error": "System error. Please contact the shop owner or try again later.",
        "order_comment_and_message.rate_limit_error": "You've reached today's message limit. please try again tomorrow.",
        "orders": "Pesanan",
        "orders.action.cancel": "Batalkan Pesanan",
        "orders.action.checkout": "Buat Pesanan",
        "orders.action.confirm": "Sahkan Pesanan",
        "orders.action.ship": "Tanda sebagai Dihantar",
        "orders.actions.title": "Uruskan Status Pesanan",
        "orders.comments.text.name": "Komen",
        "orders.comments.text.placeholder": "Masukkan komen untuk pesanan ini",
        "orders.comments.title": "Komen kedai dan pelanggan",
        "orders.coupons": "Tahniah! Anda layak mendapat diskaun berikut:",
        "orders.coupons.apply": "Menggunakan kupon",
        "orders.coupons.invalid": "Maaf, kupon anda tidak sah.",
        "orders.coupons.invalid.order": "Sila keluarkan kod kupon yang tidak sah sebelum membuat pesanan anda.",
        "orders.coupons.label": "Kod Kupon",
        "orders.coupons.placeholder": "Masukkan Kod Kupon",
        "orders.coupons.validation.minamount": "Maaf, pesanan anda tidak memenuhi nilai yang diperlukan untuk kupon ini",
        "orders.delivery.title": "Butiran penghantaran",
        "orders.fields.accept_terms": "Anda bersetuju dengan Terma Penggunaan dan Dasar Privasi Kedai",
        "orders.fields.accept_terms.validation.required": "Anda mesti bersetuju dengan terma dan syarat untuk meneruskan",
        "orders.fields.applied_member_point_redeem_to_cash": "Applied Point Discount",
        "orders.fields.applied_user_credits": "Applied Store Credits",
        "orders.fields.billing_address": "Alamat Pengebilan",
        "orders.fields.billto": "Bil kepada",
        "orders.fields.credits_earned_after_paid": "Credits earned after completed",
        "orders.fields.customer": "Pelanggan",
        "orders.fields.customer.phone": "Nombor telefon pelanggan",
        "orders.fields.customer_name": "Nama Pelanggan",
        "orders.fields.delivery_address": "Alamat Penghantaran",
        "orders.fields.delivery_address.remarks": "Ringkasan Penghantaran",
        "orders.fields.delivery_data.family_mart_freeze.error.locale_code": "Shop Code is required.",
        "orders.fields.delivery_data.sl_logistics_yto_store.city_list.error": "Something went wrong with this delivery option, please refresh the page or <a href=\"/cart\" class=\"alert-highlight\">go back to the previous page to select another delivery option.</a>",
        "orders.fields.delivery_data.sl_logistics_yto_store.family_mart.label": "Family Mart",
        "orders.fields.delivery_data.sl_logistics_yto_store.seven_eleven.label": "7-11",
        "orders.fields.delivery_data.sl_logistics_yto_store.store.label": "Store",
        "orders.fields.delivery_data.sl_logistics_yto_store.store_dropdown.error": "Something went wrong with the address, please select again.",
        "orders.fields.delivery_data.tw_ezship.location_code.hint": "Carian kedai",
        "orders.fields.delivery_data.tw_ezship.location_code.label": "Kod Kedai",
        "orders.fields.delivery_data.tw_ezship.location_name.label": "Nama Kedai",
        "orders.fields.delivery_data.tw_ezship.recipient_name.label": "Nama Penerima",
        "orders.fields.delivery_data.tw_ezship.sn_id.label": "ID Rujukan",
        "orders.fields.delivery_data.tw_simple_711.location_code.label": "Kod Kedai 7-11",
        "orders.fields.delivery_data.tw_simple_711.location_name.label": "Nama Kedai 7-11",
        "orders.fields.delivery_data.tw_simple_711.recipient_name.label": "Nama Penerima",
        "orders.fields.delivery_data.tw_simple_familymart.location_code.label": "Kod Kedai Family Mart",
        "orders.fields.delivery_data.tw_simple_familymart.location_name.label": "Nama Kedai Family Mart",
        "orders.fields.delivery_data.tw_simple_familymart.recipient_name.label": "Nama Penerima",
        "orders.fields.delivery_description": "Keterangan",
        "orders.fields.delivery_fee": "Caj Penghantaran",
        "orders.fields.delivery_fee_free": "Free",
        "orders.fields.delivery_method": "Kaedah Penghantaran",
        "orders.fields.member_points": "points",
        "orders.fields.options.blacklist.erro": "",
        "orders.fields.options.blacklist.error": "Produk anda ada tersedia dengan kaedah penghantaran atau pembayaran yang lain. Sila pilih kaedah lain yang sah atau membuat pesanan sewajarnya.",
        "orders.fields.order_custom_discount": "Diskaun (khas)",
        "orders.fields.order_date": "Tarikh",
        "orders.fields.order_delivery.arrived": "Arrived",
        "orders.fields.order_delivery.collected": "Collected",
        "orders.fields.order_delivery.pending": "Unfulfilled",
        "orders.fields.order_delivery.returned": "Returned",
        "orders.fields.order_delivery.returning": "Returning",
        "orders.fields.order_delivery.shipped": "Shipped",
        "orders.fields.order_delivery.shipping": "Shipping",
        "orders.fields.order_discount": "Diskaun diberi",
        "orders.fields.order_number": "No. Pesanan",
        "orders.fields.order_remarks": "Ringkasan Pesanan",
        "orders.fields.order_status": "Status",
        "orders.fields.payment_fee": "Caj Pembayaran",
        "orders.fields.payment_instructions": "Arahan Pembayaran",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_barcode": "Had atas setiap transaksi menggunakan Barcode ialah NTD20,000",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_cvs": "Had atas setiap transaksi menggunakan CVS ialah NTD20,000",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_webatm": "Had atas setiap transaksi menggunakan WebATM ialah NTD30,000",
        "orders.fields.payment_method.validation.limit_lowest.barcode": "Transaksi gagal: Amaun bayaran minimum untuk Bayaran Barcode adalah NT$30",
        "orders.fields.payment_method.validation.limit_lowest.cvs": "Transaksi gagal: Amaun bayaran minimum untuk Bayaran CVS adalah NT$30",
        "orders.fields.payment_method.validation.limit_maximum.barcode": "Transaksi gagal: Amaun maksimum pesanan untuk Bayaran Barcode adalah NT$20000",
        "orders.fields.payment_method.validation.limit_maximum.cvs": "Transaksi gagal: Amaun maksimum pesanan untuk Bayaran CVS adalah NT$20000",
        "orders.fields.payment_type": "Jenis Pembayaran",
        "orders.fields.preorder_item": "Item Pra pesanan",
        "orders.fields.product_subscription_period": "ke-{{period}}",
        "orders.fields.remaining_member_points_without_balance": "Applied {{ applied }} points",
        "orders.fields.rounding": "Rounding",
        "orders.fields.status.cancelled": "Dibatalkan",
        "orders.fields.status.completed": "Selesai",
        "orders.fields.status.confirmed": "Disahkan",
        "orders.fields.status.pending": "Belum Selesai",
        "orders.fields.status.received": "Diterima",
        "orders.fields.status.returned": "Telah dipulangkan",
        "orders.fields.status.returning": "Dipulangkan",
        "orders.fields.status.shipped": "Dihantar",
        "orders.fields.status.temp": "Belum Selesai",
        "orders.fields.subtotal": "Jumlah kasar",
        "orders.fields.total": "Jumlah ",
        "orders.fields.user_credits": "credits",
        "orders.general.title": "Butiran pesanan",
        "orders.index.action.view": "Paparkan",
        "orders.index.no_records.action": "Pergi Membeli-belah",
        "orders.index.no_records.description": "Anda belum pernah berurus niaga di kedai ini.",
        "orders.index.no_records.title": "Anda tidak mempunyai sebarang pesanan.",
        "orders.index.title": "Pesanan",
        "orders.invoices.carrier": "Pembawa Umum",
        "orders.invoices.carrier_type.member": "Ahli",
        "orders.invoices.carrier_type.mobile_barcode": "Barcode Telefon Bimbit",
        "orders.invoices.carrier_type.npc_barcode": "Barcode NPC",
        "orders.invoices.get_invoice": "Saya perlukan resit",
        "orders.invoices.title": "Invois",
        "orders.member_point.fields.redeemed": "Points used to redeem gifts",
        "orders.member_point.pos_settled_content": "Points earned {{ pending_days }} day(s) after POS order completed",
        "orders.member_point.settled_after_content": "Points earned {{ pending_days }} day(s) after pick up",
        "orders.member_point.settled_after_order_completed": "Points earned after completed",
        "orders.member_point.unit": "point(s)",
        "orders.notifications.title": "Notifikasi Perkembangan Pesanan",
        "orders.payment.title": "Butiran pembayaran",
        "orders.payment_slip.footer": "Maklumat pembayaran anda mengisi hanya untuk pemeriksaan bayaran dan telah dilindungi dengan sistem sekuriti. Anda boleh membuat bayaran dengan lega.",
        "orders.payment_slip.order_info.amount": "Jumlah kasar",
        "orders.payment_slip.order_info.instructions": "Arahan pembayaran",
        "orders.payment_slip.order_info.read_more": "Arahan View Full",
        "orders.payment_slip.upload_form.hint": "Selepas mengesahkan pembayaran, kami akan menguruskan penghantaran secepat mungkin!",
        "orders.payment_slip.upload_form.image_input.change": "Klik untuk menukar gambar",
        "orders.payment_slip.upload_form.image_input.description": "Sila sahkan bahawa imej adalah jelas dengan termasuk nombor akaun, masa transaksi, jumlah transaksi",
        "orders.payment_slip.upload_form.image_input.error": "Saiz gambar mestilah lebih kecil daripada 10MB",
        "orders.payment_slip.upload_form.image_input.title": "Muat naik butiran bayaran",
        "orders.payment_slip.upload_form.message": "Nyatakan catatan pembayaran",
        "orders.payment_slip.upload_form.message.error": "Tidak boleh melebihi {{ n }} aksara",
        "orders.payment_slip.upload_form.notification": "Untuk mendapatkan pemberitahuan perintah terkini, sila layari",
        "orders.payment_slip.upload_form.paid_time": "Masa pembayaran",
        "orders.payment_slip.upload_form.title": "Sila muat naikan butiran pembayaran selepas selesai bayaran",
        "orders.payment_slip.uploaded.alert": "Terima Kasih untuk butiran pembayaran, kami akan mengesahkan secepat mungkin!",
        "orders.payment_slip.uploaded.notification": "Langgan untuk mendapatkan maklumat order terkini.",
        "orders.payment_slip.uploaded.order_link": "Lihat Pesanan",
        "orders.payment_slip.uploaded.paid_time": "Bayaran:",
        "orders.payment_slip.uploaded.title": "Berikut di bawah adalah butiran pemindahan anda",
        "orders.payment_slip.uploaded.upload_time": "Kemas kini Masa Proof:",
        "orders.payment_slip.uploaded_without_login.hint": "Sila log masuk untuk melihat butiran",
        "orders.payment_slip.uploaded_without_login.title": "Terima kasih! Maklumat pemindahan pembayaran telah dimuat naik untuk pesanan ini",
        "orders.products.title": "Butiran Produk",
        "orders.promotion_coupons.placeholder": "Masukkan Kod Kupon",
        "orders.promotion_type.bundle_amount": "Bundle",
        "orders.promotion_type.bundle_gift": "Bundle",
        "orders.promotion_type.bundle_group": "A+B",
        "orders.promotion_type.bundle_group_amount": "A+B",
        "orders.promotion_type.bundle_group_gift": "A+B",
        "orders.promotion_type.bundle_group_percentage": "A+B",
        "orders.promotion_type.bundle_percentage": "Bundle",
        "orders.promotion_type.bundle_pricing": "Bundle",
        "orders.promotion_type.buyandget_free": "Buy X Get Y",
        "orders.promotion_type.buyandget_percentage": "Buy X Get Y",
        "orders.promotion_type.buyandget_pricing": "Buy X Get Y",
        "orders.promotion_type.coupon": "Coupon",
        "orders.promotion_type.credit_reward": "Reward Credits",
        "orders.promotion_type.custom_discount": "Custom Discount",
        "orders.promotion_type.earn_purchase_points": "Earning Points",
        "orders.promotion_type.free_shipping": "Free Shipping Promotion",
        "orders.promotion_type.member_point_redeem_gift": "Points Campaign",
        "orders.promotion_type.membership_offer": "Member Offer",
        "orders.promotion_type.point_reward": "Reward Points",
        "orders.promotion_type.promotion": "Promotion",
        "orders.promotion_type.reward_credit": "Reward Credits",
        "orders.reward_credit.accumulated_auto_reward": "Earn {{ credit_value }} credits for every {{ credit_threshold }}",
        "orders.reward_credit.auto_reward": "Get {{ credit_value }} credits over {{ credit_threshold }}",
        "orders.reward_credit.balance": "Buy {{ auto_reward_balance }} more to get the offer",
        "orders.reward_credit.earned_after_order_completed_faq": "You can earn the points after the order is completed and use them on your next order. Please note that the points are calculated based on the amount after the discount.",
        "orders.reward_credit.faq": "You can earn the points after the payment is completed and use them on your next purchase.",
        "orders.reward_credit.value": "{{ credit_value }} credits",
        "orders.reward_point.earned_after_order_completed_faq": "You can earn the points after the order is completed and use them on your next order. Please note that the points are calculated based on the amount after the discount.",
        "orders.reward_point.faq": "You can earn the points after the order is completed and use them on your next purchase.",
        "orders.reward_point.value": "{{ point_value }} points",
        "orders.show.check_order.description": "You can view or cancel the order in the <a href=\"{{pagePath}}\">Member Center> Orders</a>",
        "orders.show.check_order.title": "Check order",
        "orders.show.customer_cancel_order.button.cancel": "Cancel Order",
        "orders.show.customer_cancel_order.button.ok": "OK",
        "orders.show.customer_cancel_order.confirm.description.integrated": "Sorry to see you cancel. Please tell us the reason, and we will try to make your next shopping experience better! Refund will be made after cancellation.",
        "orders.show.customer_cancel_order.confirm.description.non_integrated": "Sorry to see you cancel. Please tell us the reason, and we will try to make your next shopping experience better! It may take a few days to process the refund, please wait patiently.",
        "orders.show.customer_cancel_order.confirm.failed.description": "If the retry fails, please contact us at \"Shop and Customer Comments\" below.",
        "orders.show.customer_cancel_order.confirm.failed.title": "Oops! Cancellation had failed.",
        "orders.show.customer_cancel_order.confirm.loading.description": "Please wait for a moment. Don't leave or return to the previous page.",
        "orders.show.customer_cancel_order.confirm.loading.title": "Processing",
        "orders.show.customer_cancel_order.confirm.success.description": "Email notification will be sent after successful cancellation",
        "orders.show.customer_cancel_order.confirm.success.title": "Cancellation request is send",
        "orders.show.customer_cancel_order.confirm.title": "Are you sure you want to cancel?",
        "orders.show.customer_cancel_order.reasons.change_item": "Want to change the purchase item",
        "orders.show.customer_cancel_order.reasons.change_mind": "Change your mind",
        "orders.show.customer_cancel_order.reasons.default": "Please select a reason for cancellation",
        "orders.show.customer_cancel_order.reasons.expensive_price": "The price is more expensive than elsewhere",
        "orders.show.customer_cancel_order.reasons.hint": "Reason for cancellation",
        "orders.show.customer_cancel_order.reasons.incorrect_customer_info": "Entered incorrect delivery or payment information",
        "orders.show.customer_cancel_order.reasons.other": "Other",
        "orders.show.customer_cancel_order.reasons.other.placeholder": "Please tell us the reason.",
        "orders.show.customer_cancel_order.reasons.repeat_purchase": "Repeat purchase",
        "orders.show.customer_cancel_order.reasons.wait_too_long": "Wait too long for shipment",
        "orders.show.message.shipped.description": " ",
        "orders.show.message.shipped.title": "Item anda telah dihantar",
        "orders.show.message.thankyou.description": " ",
        "orders.show.message.thankyou.title": "Terima kasih kerana membuat pesanan",
        "orders.show.thankyou.continue": "Teruskan membeli-belah sekarang!",
        "payment.action.confirm": "Sahkan",
        "payment.cc.cashier.footer": "The payment service is powered by SHOPLINE Payments",
        "payment.cc.cvc": "CVC",
        "payment.cc.cvc.hint": "3 angka kod keselamatan yang biasanya terdapat di belakang kad anda.",
        "payment.cc.cvc.placeholder": "CVC",
        "payment.cc.expirydate": "Tarikh Luput",
        "payment.cc.expirydate.placeholder": "MM/YY",
        "payment.cc.fields.accept_terms": "Saya bersetuju dengan Terma Penggunaan dan Dasar Privasi",
        "payment.cc.fields.accept_terms.validation.required": "Anda mesti bersetuju dengan Terma dan Syarat untuk meneruskan",
        "payment.cc.holdername": "Nama Pemegang Kad",
        "payment.cc.holdername.hint": "Nama penuh sama pada kad",
        "payment.cc.holdername.placeholder": "Nama Pemegang Kad",
        "payment.cc.number": "Nombor Kad Kredit (Visa / Master)",
        "payment.cc.number.placeholder": "Nombor Kad Kredit (tiada ruang)",
        "payment.cc.tw.cashier.footer": "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
        "payment.cc.update.instructions": "Sila masukkan kad kredit anda di bawah untuk mengemas kini",
        "payments.fields.types.allpay_barcode": "Barcode menerusi Allpay",
        "payments.fields.types.allpay_credit": "Kad Kredit menerusi Allpay",
        "payments.fields.types.allpay_cvs": "CVS menerusi Allpay",
        "payments.fields.types.allpay_webatm": "WebATM menerusi Allpay",
        "payments.fields.types.asiapay": "Kad Kredit menerusi Asiapay",
        "payments.fields.types.bank_transfer": "Pembayaran melalui bank",
        "payments.fields.types.cash_on_delivery": "Tunai Atas Penghantaran",
        "payments.fields.types.credit_card": "Kad kredit",
        "payments.fields.types.custom": "Khas",
        "payments.fields.types.esun": "Kad Kredit Esun",
        "payments.fields.types.ezship": "Bayar di Kedai Pungutan menerusi ezShip",
        "payments.fields.types.free_checkout": "Semakan Keluar Percuma",
        "payments.fields.types.paypal": "Kad kredit atau Paypal",
        "payments.fields.types.paypal_express": "Kad kredit atau Paypal",
        "payments.fields.types.prizm": "Kredit Visa / Master",
        "paypal.language": "en_US",
        "porduct_sales_sold_count.max": "Sold <b>90M+</b>",
        "porduct_sales_sold_count.than_10": "Sold <b>{{count}}+</b>",
        "porduct_sales_sold_count.than_100": "Sold <b>{{count}}+</b>",
        "porduct_sales_sold_count.than_1000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_10000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_100000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_1000000": "Sold <b>{{digit7}}M+</b>",
        "porduct_sales_sold_count.than_10000000": "Sold <b>{{digit7}}M+</b>",
        "product.add_to_cart": "Masukkan dalam Troli",
        "product.add_to_cart_fail": "Your cart is full!",
        "product.addon_products.add_to_cart.hint": "Item berjaya ditambah ke dalam troli anda",
        "product.addon_products.errors.addon_product_out_of_stock": "Item tambahan tidak mempunyai stok yang mencukupi",
        "product.addon_products.errors.larger_addon_product": "Bilangan item tambahan tidak boleh melebihi bilangan produk utama",
        "product.addon_products.errors.main_product_out_of_stock": "Produk utama tidak mempunyai stok yang mencukupi",
        "product.addon_products.errors.out_of_stock": "Stok tidak mencukupi untuk {{title}} produk tambahan.",
        "product.addon_products.errors.reached_max_purchase_quantity": "Had {{ message }} setiap pesanan.",
        "product.addon_products.label": "Item Tambahan",
        "product.addon_products.tips.limit_exceed": "Apabila anda melaraskan kuantiti, bilangan item tambahan tidak boleh melebihi bilangan produk utama.",
        "product.amazon_product_review.show_more": "Show more",
        "product.available_time_info.end.1": "Product will be unavailable on ",
        "product.available_time_info.end.2": "",
        "product.available_time_info.start.1": "Product available from ",
        "product.available_time_info.start.2": "",
        "product.available_time_over": "AVAILABLE TIME OVER",
        "product.bundle_group_products.label": "A + B",
        "product.bundled_products.label": "Pakej",
        "product.buy_now": "Beli Sekarang",
        "product.buy_now.preorder.hint": "Now taking pre-orders",
        "product.buy_together": "Beli sekali",
        "product.buyandget.label": "Buy X Get Y",
        "product.coming_soon": "COMING SOON",
        "product.gift.label": "Free Gift",
        "product.member_only": "Member Only",
        "product.out_of_stock": "Kehabisan stok",
        "product.page.add_to_cart_count": "Sudah ditambah <span class=\"order-detail-count\">{{count}}</span> item",
        "product.page.quantity": "Kuantiti",
        "product.page.subtotal": "Jumlah kasar",
        "product.page.title.product-info": "Produk",
        "product.page.unit_price": "Harga Seunit",
        "product.preorder_limit.hint": "The purchase quantity includes both in-stock and preordered items.",
        "product.product_review.no_review": "No review for this product",
        "product.product_review.out_of_5_stars": "out of 5 stars",
        "product.product_review.rating_source_amazon": "Rating Source: Amazon",
        "product.product_review.rating_source_shopline": "Rating Source: This Shop",
        "product.product_review.reviews": "Reviews",
        "product.product_review.stars": "Stars",
        "product.set.open_variation": "View product details",
        "product.store_stock.check_stock": "Check Stock Availability at Stores",
        "product.subscription_product.label": "Subscription Product",
        "product.tier_member_only": "{{tierName}} Only",
        "product.view_less": "Hide content",
        "product.view_more": "Show more",
        "product_review_comments.modal.content.character": "Word count",
        "product_review_comments.modal.content.character_hint": "At least {{ min_length }} words",
        "product_review_comments.modal.content.img": "Image",
        "product_review_comments.modal.content.img_hint": "Upload at least one image",
        "product_review_comments.modal.content.no_limit.character": "No word count requirement",
        "product_review_comments.modal.content.no_limit.img": "No requirement",
        "product_review_comments.modal.content.no_limit.time": "No time limit",
        "product_review_comments.modal.content.time": "Review time",
        "product_review_comments.modal.content.time_hint": "Submit review within {{ deadline_days }} days of order completion",
        "product_review_comments.modal.title": "Review Reward Rules",
        "product_review_comments.orders.back_to_my_account": "< Back to My Account",
        "product_review_comments.orders.back_to_the_store": "Back to Store",
        "product_review_comments.orders.comment": "Comment",
        "product_review_comments.orders.comment_placeholder": "(Optional) Satisfied with your purchase? Tell us your thoughts!",
        "product_review_comments.orders.completed_all_reviews": "Congratulations! You've completed all reviews!",
        "product_review_comments.orders.empty.title": "No products to reviews",
        "product_review_comments.orders.finished_review.desc.1": "Earn {{ value }} {{ type }} by submitting a review now!",
        "product_review_comments.orders.finished_review.desc.2": "Earn {{ value }} {{ type }} by submitting a review before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.3": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words!",
        "product_review_comments.orders.finished_review.desc.4": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.5": "Earn {{ value }} {{ type }} by submitting a review with an image!",
        "product_review_comments.orders.finished_review.desc.6": "Earn {{ value }} {{ type }} by submitting a review with an image before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.7": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words and an image!",
        "product_review_comments.orders.finished_review.desc.8": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words and an image before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.member_point": "If it meets the campaign requirements, you will receive {{ value }} member points later.",
        "product_review_comments.orders.finished_review.desc.user_credit": "If it meets the campaign requirements, you will receive {{ value }} store credits later.",
        "product_review_comments.orders.finished_review.title": "Thank you for your review!",
        "product_review_comments.orders.max_length_of_characters": "Within 2000 characters",
        "product_review_comments.orders.order_id": "Order ID:",
        "product_review_comments.orders.orders_to_view": "Orders to review",
        "product_review_comments.orders.purchased_date": "Purchased Date:",
        "product_review_comments.orders.rate_other_order": "Rate Other Order",
        "product_review_comments.orders.review": "Review",
        "product_review_comments.orders.send": "Send",
        "product_review_comments.orders.upload_image": "Upload image (maximum 9)",
        "product_review_comments.orders.write_a_review": "Write a review",
        "product_review_entry.review_button_text": "Write a review",
        "product_review_entry.review_description_content": "Enjoyed what you bought? Please give us a thumbs-up review!",
        "product_review_entry.review_description_title": "We are waiting for your review!",
        "product_review_entry.review_description_title.member_point": "We're waiting for your review! Review now and earn {{ value }} points!",
        "product_review_entry.review_description_title.user_credit": "We're waiting for your review! Review now and earn {{ value }} store credits!",
        "product_set.add_to_cart": "ADD TO CART",
        "product_set.add_to_set": "Add to set",
        "product_set.build": "Build your product set",
        "product_set.exceed_limit": "Exceed product set purchase limit, please adjust your quantity.",
        "product_set.items_needed": "<span class=\"highlight-label\">{{ quantity }}</span> item(s) needed",
        "product_set.items_needed.diff": "{{ currentQuantity }} item(s) selected, you still need <span class=\"highlight-label\">{{ stillNeedQuantity }}</span> item(s) to get your discount!",
        "product_set.items_needed.hint": "<span class=\"highlight-label\">{{ quantity }}</span> more products to complete the set",
        "product_set.items_selected": "<span class=\"highlight-label\">{{ quantity }}</span> item(s) selected",
        "product_set.no_items_selected": "No items selected",
        "product_set.not_enough_stock": "Not enough stock, please adjust your quantity.",
        "product_set.not_enough_stock.please_remove": "Not enough stock, please remove this item.",
        "product_set.please_select": "Please select your item",
        "product_set.quantity": "Product set quantity",
        "product_set.quantity_label.qualified": "{{ quantity }} item(s) selected",
        "product_set.quantity_label.unqualified": "{{ quantity }} item(s) needed",
        "product_set.quick_cart.add_to_set": "Add to set",
        "product_set.reach_limit": "Purchase limit reached",
        "product_set.reach_limit.congrats": "<span class=\"highlight-label\">{{ quantity }}</span> item(s) selected, congrats on the discount you've got!",
        "product_set.set_includes": "Set Includes:",
        "product_set.sold_out": "Not enough stock",
        "product_set.special_offer": "Product Set Special Offer",
        "product_set.subtitle.qualified": "You are qualified for discount. Add to cart now!",
        "product_set.subtitle.unqualified": "Add the following products now; select <span class=\"highlight-label\">{{ quantity }}</span> more products to complete the set and add to cart",
        "products.category.advance_filter.apply": "Laksanakan Penapis",
        "products.category.advance_filter.clear": "pemilihan yang jelas",
        "products.category.advance_filter.clear_all": "Kosongkan semua",
        "products.category.advance_filter.placeholder.max_price": "Dagangan",
        "products.category.advance_filter.placeholder.min_price": "min",
        "products.category.advance_filter.show_less": "Tunjukkan kurang",
        "products.category.advance_filter.show_more": "menunjukkan lebih",
        "products.category.advance_filter.tag.max_price": "≤ {{ max_price }}",
        "products.category.advance_filter.tag.min_price": "≥ {{ min_price }}",
        "products.category.advance_filter.tag.price_range": "{{ min_price }} ~ {{ max_price }}",
        "products.category.advance_filter.title": "penapis",
        "products.category.advance_filter.type.brand": "jenama",
        "products.category.advance_filter.type.color": "Warna",
        "products.category.advance_filter.type.material": "bahan",
        "products.category.advance_filter.type.price": "Julat harga ({{ currency }})",
        "products.category.advance_filter.type.size": "saiz",
        "products.message.button_cancel": "Batal",
        "products.message.button_ok": "OK",
        "products.message.title": "Anda pasti mahu mengeluarkan produk ini?",
        "products.purchase_limit_hint": "Limit {{limit}} per customer",
        "products.purchase_limit_hint_can_not_purchase": "Limit {{limit}} per customer. You have already purchased to limit.",
        "products.quick_cart.add_to_cart": "MASUKKAN DALAM TROLI",
        "products.quick_cart.insufficient_point": "Not enough points, please remove some gifts",
        "products.quick_cart.low_stock_hint": "Stok tidak mencukupi.\n Sila laraskan kuantiti anda.",
        "products.quick_cart.message": "MESEJ",
        "products.quick_cart.messagetobuy": "Sila hantar mesej kepada tuan kedai untuk butiran pesanan.",
        "products.quick_cart.out_of_number_hint": "Out of stock/preorder quantity",
        "products.quick_cart.out_of_stock": "HABIS DIJUAL",
        "products.quick_cart.out_of_stock_hint": "Stok tidak mencukupi. Item anda tidak ditambah ke dalam troli.",
        "products.quick_cart.preorder_now": "PRA PESAN SEKARANG",
        "products.quick_cart.quantity": "Kuantiti",
        "products.quick_cart.quantity_invalid": "",
        "products.quick_cart.quantity_of_stock_hint": "Hanya {{message}} item yang tinggal.",
        "products.quick_cart.reached_max_purchase_quantity": "Had {{ message }} setiap pesanan.",
        "products.quick_cart.show_more": "Butiran Lanjut",
        "products.variant_selector.hide": "Hide",
        "products.variant_selector.view_other_variations": "View other {{count}} variants",
        "promotions.available_platform.app": "App",
        "promotions.available_platform.ec": "Online Store",
        "promotions.available_platform.only": "{{platform}} Only",
        "promotions.available_platform.retail": "Retail Store",
        "promotions.available_platform.selected_retail": "Selected Stores",
        "promotions.exclude.items.hint.member_point": "Member Point Usage",
        "promotions.exclude.items.hint.member_tier": "Membership % Offer",
        "promotions.exclude.items.hint.order_discount": "Order-Level Discount",
        "promotions.exclude.items.hint.reward_campaign": "Order-level Reward Campaign",
        "promotions.exclude.items.hint.title": "Best priced product is not applicable to:",
        "promotions.exclude.items.hint.user_credit": "Store Credit Usage",
        "promotions.page.available_platform": "Available Channels: ",
        "promotions.page.display_local_timezone": "Display in your time zone<br/>(GMT{{offset}})",
        "promotions.page.end_at": "Ends on <b class=\"local-datetime\">{{date}}</b>",
        "promotions.page.first_purchase_only": "<b>1st Purchase</b> Only",
        "promotions.page.first_purchase_only.with_platform": "<b>1st Purchase</b> Only in {{platform}}",
        "promotions.page.redeem_gift.end_at": "Campaign ends on <b class=\"local-datetime\">{{date}}</b>",
        "promotions.page.redeem_gift.start_at": "Campaign begins on <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.start_at": "Begins on <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.term.confirm": "Confirm",
        "promotions.page.term.default": "＊Promotion applied is subject to order summary shown in shopping cart.\n＊Customer should checkout with valid payment & delivery method to enjoy promotion.\n＊Customer should login to checkout for member-only promotion.",
        "promotions.page.term.title": "Term & Condition",
        "promotions.section.discount_percentage.caption": "potongan {{ value }}%",
        "promotions.section.discount_summary.content": "{{ benefits }}{{ criteria }}",
        "promotions.section.discount_summary.criteria.bundle_amount": "Selected Products: Buy {{ itemCount }} items for {{ discountValue }}% off.",
        "promotions.section.discount_summary.criteria.bundle_gift": "Selected Products: Buy {{ itemCount }} items for {{ discountValue }} Free Gift(s) ({{ giftName }})",
        "promotions.section.discount_summary.criteria.bundle_group": "Selected Product: Buy {{ red_count }} in <span class=\"bundle-group-label bundle-group-red\">Group A</span> & {{ green_count }} in <span class=\"bundle-group-label bundle-group-green\">Group B</span> for {{ total }}.",
        "promotions.section.discount_summary.criteria.bundle_group.is_accumulated": " Buy more, Save more!",
        "promotions.section.discount_summary.criteria.bundle_group.is_not_accumulated": " Limited offer for your first set.",
        "promotions.section.discount_summary.criteria.bundle_group_amount": "Selected Product: Buy {{ red_count }} in <span class=\"bundle-group-label bundle-group-red\">Group A</span> & {{ green_count }} in <span class=\"bundle-group-label bundle-group-green\">Group B</span> for {{ total }} off.",
        "promotions.section.discount_summary.criteria.bundle_group_gift": "Selected Product: Buy {{ red_count }} in <span class=\"bundle-group-label bundle-group-red\">Group A</span> & {{ green_count }} in <span class=\"bundle-group-label bundle-group-green\">Group B</span> for {{ total }} Free Gift(s) ({{ giftName }})",
        "promotions.section.discount_summary.criteria.bundle_group_percentage": "Selected Product: Buy {{ red_count }} in <span class=\"bundle-group-label bundle-group-red\">Group A</span> & {{ green_count }} in <span class=\"bundle-group-label bundle-group-green\">Group B</span> for {{ total }}% off.",
        "promotions.section.discount_summary.criteria.bundle_percentage": "Selected Products: Buy {{ itemCount }} items for {{ discountValue }} off.",
        "promotions.section.discount_summary.criteria.bundle_pricing": "Selected Products: Buy {{ itemCount }} items for {{ discountValue }}",
        "promotions.section.discount_summary.criteria.scope_discounted_products": "<b>Produk Terpilih</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_products.content": " dengan pembelian <b>Produk Terpilih</b> melebihi <b>{{ condition_value }}</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal": "<b>Keseluruhan Pesanan</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal.content": " dengan pembelian melebihi <b>{{ condition_value }}</b>",
        "promotions.section.discount_summary.criteria.type_quantity": "{{ count }} item",
        "promotions.section.discount_summary.discount_value": "<b>{{ type == \"amount\" ? Currency : \"\"  }}{{ value }}{{ type == \"percentage\" ? \"%\":\"\"  }}</b>",
        "promotions.section.discount_summary.set.on_item": "Dapatkan potongan diskaun sebanyak  <b>{{ discount_value }}</b> untuk <b>Produk Terpilih</b>",
        "promotions.section.discount_summary.set.on_order": "Dapatkan potongan diskaun sebanyak <b>{{ discount_value }}</b> untuk <b>Keseluruhan Pesanan</b>",
        "purchase_limit_hint.purchasable": "Limit {{limit}} per customer. You can only purchase {{purchasable_qty}} more.",
        "recaptcha.language": "bm",
        "redirect.go_home_in_seconds": "Return to Home page in {{seconds}} seconds",
        "return_order.back_to_order_detail": "Back to order information page",
        "return_order.confirmation": "Return Order Confirmation",
        "return_order.confirmation.refund_note": "The acutal refund amount will be displayed on <a href=\"{{ link }}\">Return Order Information Page</a>.",
        "return_order.confirmation.refund_question": "Please <a id=\"js-contact-us\">Contact Us</a> if you have any question.",
        "return_order.coninue_shopping": "Continue Shopping",
        "return_order.delivery_status.arrived": "Arrived",
        "return_order.delivery_status.no_return": "Return not required",
        "return_order.delivery_status.pending": "Returning",
        "return_order.delivery_status.return_collected": "Returned",
        "return_order.delivery_status.returned": "Returned",
        "return_order.delivery_status.returning": "Returning",
        "return_order.detail.apply_date": "Apply Date",
        "return_order.detail.confirmation_emailed": "An return order confirmation email will be sent to below email",
        "return_order.detail.order_submitted": "Your return order has been submitted!",
        "return_order.detail.return_order_no": "Return Order No.",
        "return_order.fill_infomation": "Fill Return Information",
        "return_order.form.agree_return_policy": "I agree to the shop's <a href=\"{{ link }}\" target=\"_blank\" rel=\"noopener\">Return Policy</a>",
        "return_order.form.submit": "Confirm Return Order",
        "return_order.form.validation": "You must agree with the return policy",
        "return_order.inspect.status": "Return Inspection Status",
        "return_order.inspect.status.fail": "Fail",
        "return_order.inspect.status.no_inspect": "Inspection not required",
        "return_order.inspect.status.pass": "Pass",
        "return_order.inspect.status.pending": "Uninspected",
        "return_order.order_number": "Order Number",
        "return_order.payment_record.pending": "Pending",
        "return_order.payment_status.pending": "Pending",
        "return_order.payment_status.refunded": "Refunded",
        "return_order.popup.failed.confirm": "OK",
        "return_order.popup.failed.content": "This shipping method cannot exceed TWD {{ amount }}. Please change the logistics again.",
        "return_order.popup.failed.title": "Return Failed !",
        "return_order.prcie_amount": "Subtotal",
        "return_order.product_name": "Product Name",
        "return_order.quantity": "Quantity",
        "return_order.refund.amount": "Refund Amount",
        "return_order.refund.date": "Refund Date",
        "return_order.refund.record": "Refund Record",
        "return_order.return.total": "Return total",
        "return_order.return_delivery.delivery_option": "Return Delivery Type",
        "return_order.return_delivery.destination": "Shipping Destination",
        "return_order.return_delivery.info": "Delivery Details",
        "return_order.return_delivery.optional": "Optional",
        "return_order.return_delivery.receiver_address": "Return Address",
        "return_order.return_delivery.receiver_name": "Return Name",
        "return_order.return_delivery.receiver_phone": "Return Phone",
        "return_order.return_delivery.status": "Return Delivery Status",
        "return_order.return_payment.bank_account": "Bank Name & Account",
        "return_order.return_payment.bank_transfer_placeholder": "812 TSBank xxxxxxxxxxxx",
        "return_order.return_payment.bank_transfer_return": "Provide refund account",
        "return_order.return_payment.custom_return": "Others（Please contact us for refund details）",
        "return_order.return_payment.info": "Refund Details",
        "return_order.return_payment.payment_option": "Return Payment Type",
        "return_order.return_payment.status": "Refund Status",
        "return_order.return_quantity": "Return Quantity",
        "return_order.return_reason": "Return Reason",
        "return_order.return_reason.admin_return_order": "Return By Merchant",
        "return_order.return_reason.broke_during_delivery": "Parcel damaged on arrival",
        "return_order.return_reason.not_expected": "Not as expected",
        "return_order.return_reason.other": "Others",
        "return_order.return_reason.return_remark": "Please specify in additional note",
        "return_order.return_reason.return_remark_placeholder": "60 characters",
        "return_order.return_reason.wrong_item": "Incorrect item received",
        "return_order.return_reason.wrong_variation": "Size issue",
        "return_order.select_return_product": "Select Return Product",
        "return_order.status": "Return Order Status",
        "return_order.status.cancelled": "Return cancelled",
        "return_order.status.completed": "Return completed",
        "return_order.status.confirmed": "Return confirmed",
        "return_order.status.pending": "Return in progress",
        "return_order.unit_price": "Unit Price",
        "save_fields.customer_info.birthday": "Tarikh lahir pelanggan",
        "saved_stores.update.failure": "Update failed, please try again",
        "session.forget_passowrd.check_phone.error": "Nombor telefon bimbit salah. Sila semak semula",
        "session.forget_passowrd.error": "Email or mobile number is invalid",
        "session.forgot_password": "Lupa Kata Laluan",
        "session.login.success": "Logged in successfully",
        "session.mobile_center.check_phone.error": "Nombor telefon bimbit sudah digunakan",
        "session.mobile_signup.check_mobile.go_back.1": "anda boleh",
        "session.mobile_signup.check_mobile.go_back.2": "kembali",
        "session.mobile_signup.check_mobile.go_back.3": "untuk membetulkan nombor telefon bimbit sekiranya salah",
        "session.mobile_signup.check_mobile.go_back.3.simplified": "to correct mobile number",
        "session.mobile_signup.check_mobile.send_code": "Sila hantar kod pemeriksaan",
        "session.mobile_signup.check_mobile.title": "Sila semak nombor telefon bimbit anda adalah betul seperti berikut, sms akan dihantar kepada nombor telefon ini",
        "session.mobile_signup.check_mobile.your_number": "Nombor telefon bimbit anda",
        "session.mobile_signup.check_mobile.your_number.hint": "Sila masukkan nombor telefon bimbit Taiwan (bermula dengan 09)",
        "session.mobile_signup.go_back": "Back",
        "session.mobile_signup.input_code.hint": "Sila masukkan kod pemeriksaan yang anda terima",
        "session.mobile_signup.input_code.hint.simplified": "Please input check code you received",
        "session.mobile_signup.input_code.placeholder": "Check code",
        "session.mobile_signup.input_code.resend": "Hantar semula sms kod pemeriksaan ke telefon bimbit saya",
        "session.mobile_signup.input_code.resend.countdown": "Hantar semula sms kod pemeriksaan ke telefon bimbit saya ({{resendCountdown}} saat)",
        "session.mobile_signup.input_code.resend.countdown.simplified": "Resend check code ({{resendCountdown}} sec)",
        "session.mobile_signup.input_code.resend.simplified": "Resend check code",
        "session.mobile_signup.input_code.submit": "Pergi",
        "session.mobile_signup.recaptcha.checkbox.error": "Verification code will be sent after you pass reCAPTCHA",
        "session.mobile_signup.recaptcha.load.failure": "Google reCAPTCHA failed to load. Please ensure your network connection is stable and restart the app.",
        "session.mobile_signup.recaptcha.token.failure": "An error occurred. Please ensure your network connection is stable and restart the app.",
        "session.signin.facebook": "Daftar Masuk Facebook",
        "session.signin.submit": "Daftar Masuk",
        "session.signin.title": "Daftar Masuk",
        "session.signup.facebook": "Daftar Masuk Facebook",
        "session.signup.success": "Sign up successful. You're now logged in.",
        "session.signup.title": "Daftar",
        "session.terms": "Dengan meneruskan penggunaan perkhidmatan ini, anda bersetuju dengan terma dan syarat kami.",
        "session.terms.facebook": "Daftar dengan Facebook",
        "sessions.or": "ATAU",
        "sms_messenger_checkbox.subscribe": "Send via SMS",
        "store_credits.bulk_imported": "Manually added",
        "store_credits.credit_balance": "Baki Kredit",
        "store_credits.credit_history": "Rekod Kredit",
        "store_credits.fields.auto_reward": " gets reward credits",
        "store_credits.fields.auto_reward_prefix": "Order ",
        "store_credits.fields.balance": "Baki Kredit",
        "store_credits.fields.birthday_credit": "Kredit Hari Jadi",
        "store_credits.fields.date": "Tarikh",
        "store_credits.fields.display.never_expired": "Never Expired",
        "store_credits.fields.expiry_date": "Tarikh Luput",
        "store_credits.fields.member_info_quick_completion_credit": "Member Profile Completion Reward Credits",
        "store_credits.fields.member_referral_credit": "Refer new member to sign up",
        "store_credits.fields.never_expires": "Tidak Akan Luput",
        "store_credits.fields.never_expires_point": "Points Never Expired",
        "store_credits.fields.order_prefix": "Penggunaan kredit dalam pesanan",
        "store_credits.fields.product_review_reward": "Completed review for order <a href=\"{{link}}\">{{ orderNumber }}</a>",
        "store_credits.fields.remarks": "Sebab Perubahan Kredit",
        "store_credits.fields.revert_credit": "Kredit dikembalikan daripada pesanan yang dibatalkan",
        "store_credits.fields.revert_credit.order_edit": "Credits reverted from edited order",
        "store_credits.fields.revert_credit.order_split": "Credits reverted from split order",
        "store_credits.fields.revert_credit.return": "Credit Reverted from Returned order",
        "store_credits.fields.revert_credit.return_order_revert": "Reverted credits; from return",
        "store_credits.fields.user_credit_expired": "Kredit Luput",
        "store_credits.fields.value": "Pergerakan Kredit",
        "store_credits.fields.welcome_credit": "Kredit Aluan",
        "store_credits.fields.welcome_member_referral_credit": "Sign up with referral link",
        "store_credits.no_data": "Tiada rekod kredit",
        "store_credits.title": "Kredit Kedai",
        "store_stock.available": "Available for online purchase, pickup at store",
        "store_stock.current_availability": "Current Store Availability",
        "store_stock.description": "We sell products based on on-site availability and only reserve inventory for customers who have completed their booking. We recommend placing your order and confirming your pickup date before coming to the store.",
        "store_stock.loading": "Checking stock availability",
        "store_stock.sold_out": "SOLD OUT",
        "store_stock.take_a_while": "This will take a while...",
        "subscribe.facebook.dialog.cancel": "Cancel",
        "subscribe.facebook.dialog.info": "Due to updates in Facebook’s messaging guidelines, please complete the subscription process on Messenger. Click \"Subscribe now\" and you will be directed to Messenger.<br />Log in to Messenger and <span class=\"facebook-subscription-dialog-hint\">click the \"Get Started\" button</span> in the chat. You will be redirected to Messenger to complete the subscription. (If you've previously messaged the store's Facebook Page, opening the conversation on Messenger will be considered a successful subscription.)",
        "subscribe.facebook.dialog.subscribe": "Subscribe now",
        "subscribe.facebook.dialog.title": "Subscribe to Facebook",
        "subscribe.facebook.failure": "Failed to subscribe. Please log in to Facebook again.",
        "subscribe.failure": "Failed to subscribe. Please contact the store.",
        "subscribe.failure.already_bound": "Failed to subscribe. This social account is already bound to another member. Please contact the store to unbind.",
        "subscribe.line.failure": "Failed to subscribe. Please log in to LINE again.",
        "subscribe.line.failure.already_used": "Failed to subscribe. This LINE account is already used for registration by another member. Please log in with the LINE account and try again.",
        "subscribe.line.failure.different_id": "Failed to subscribe. Please log in with the LINE account of the member account.",
        "subscribe.success": "Subscribed successfully.",
        "tax.applied_store_credit": "Applied Store Credits",
        "tax.calculate_tax": "Calculate Tax",
        "tax.calculate_tax.info.1": "Please update tax and click",
        "tax.calculate_tax.info.2": "before checkout",
        "tax.calculation_content": "(Total of taxed products - Discounts) * Tax + Delivery fee * Tax",
        "tax.calculation_title": "Tax Calculation：",
        "tax.delivery_tax": "運費稅",
        "tax.delivery_tax_rate": "Delivery Tax Rate",
        "tax.discounts": "Discounts and Promotions",
        "tax.fee": "Tax fee",
        "tax.price_updated": "Price updated",
        "tax.product_price": "Product Price",
        "tax.sales_tax": "Sales Tax",
        "tax.sales_tax_rate": "Sales Tax Rate",
        "tax.service_tax": "Service tax",
        "tax.service_tax_rate": "Service Charge Rate",
        "tax.total": "Total",
        "tcat.time_slot.01": "Sebelum 13:00",
        "tcat.time_slot.02": "14:00 - 18:00",
        "tcat.time_slot.04": "Mana-mana slot masa",
        "tcat.time_slot.title": "Slot Masa Ketibaan",
        "trial_order_dialog.checkout": "Start Checkout",
        "trial_order_dialog.content": "You may : become a member, subscribe newsletter, purchase add-on items and experience other powerful features. Order limitation will be removed once the shop get upgraded.",
        "trial_order_dialog.reach_limit.check_plan": "Return to homepage",
        "trial_order_dialog.reach_limit.content": "You can continue shopping and checkout when the store is officially in operation!<br/>If you have any questions about the operation of the store, please contact the store.",
        "trial_order_dialog.reach_limit.continue": "Contact the store",
        "trial_order_dialog.reach_limit.title": "Order limit has been reached for trial operation.",
        "trial_order_dialog.title": "Welcome to checkout. The store is on free trial with up to creating 10 orders.",
        "unsubscribe.failure": "Failed to unsubscribe, please try again later.",
        "unsubscribe.success": "Unsubscribed successfully.",
        "user.add_credit_card": "Add a credit card",
        "user.add_credit_card.cancel": "Cancel",
        "user.add_credit_card.fail": "Failed to add the credit card, please try again later",
        "user.add_credit_card.remind": "Note: {{ label }} will be deducted as verification fee. It will be refunded to your card afterwards.",
        "user.add_credit_card.submit": "Submit",
        "user.add_credit_card.success": "The card has been added successfully.",
        "user.credit_card.expired": "Expired",
        "user.credit_card.system.error": "System error. Please try again later",
        "user.credit_card_list.delete": "Delete",
        "user.credit_card_list.processing": "Processing",
        "user.delete_credit_card": "Are you sure you want to delete the credit card from your account?",
        "user.delete_credit_card.cancel": "Cancel",
        "user.delete_credit_card.delete": "Delete",
        "user.delete_credit_card.description": "Once the credit card has been deleted, you need to re-enter card number for checkout next time.",
        "user.delete_credit_card.description.with_subscription_product": "Once the credit card has been deleted, you need to re-enter card number for checkout next time. If you had paid by this credit card for subscription orders, it will failed to complete the payment for the next order. You may go to Member > Orders to repay.",
        "user.delete_credit_card.fail": "Failed to delete the credit card, please try again later",
        "user.delete_credit_card.success": "The card has been deleted successfully.",
        "user.delivery_data.recipient_phone": "Nombor telefon penerima",
        "user.quick_signup.error.confirmed": "Nombor telefon bimbit ini sudah digunakan.",
        "user.quick_signup.error.confirmed.url": "Daftar masuk sekarang.",
        "user.quick_signup.error.format": "Ralat Format",
        "user.quick_signup.policy": "Saya bersetuju dengan",
        "user.quick_signup.policy.url_content": "Terma Penggunaan dan Dasar Privasi kedai",
        "user.quick_signup.policy_with_age": "By proceeding, I agree to the<a href=\"{{ link }}\"> shop's Terms of Use and Privacy Policy</a> and I am over {{ age }}",
        "user.quick_signup.promotion": "Saya mahu menerima berita dan promosi terbaru",
        "user.quick_signup.submit": "Sertai Sekarang",
        "user.quick_signup.title": "Jadi ahli sekarang!",
        "user.quick_signup.title.content": "Jangan terlepas sebarang tawaran eksklusif!",
        "user.quick_signup.validate.finish_hint": "Siapkan pendaftaran untuk menyemak dan menggunakan kredit kedai sekarang juga!",
        "user.quick_signup.validate.hint.password": "Sekurang-kurangnya 8 aksara",
        "user.quick_signup.validate.hint.resend": "Belum menerima kod pemeriksaan? Sila klik di sini untuk menghantar semula.",
        "user.quick_signup.validate.hint.send": "Kod pengesahan dihantar. Anda boleh menghantar semula kod baharu selepas {{count}} saat.",
        "user.quick_signup.validate.modify": " dan kemas kini",
        "user.quick_signup.validate.phone": "Sahkan",
        "user.quick_signup.validate.placeholder.name": "Nama",
        "user.quick_signup.validate.placeholder.password": "Masukkan kata laluan",
        "user.quick_signup.validate.placeholder.sms": "Masukkan kod pengesahan",
        "user.quick_signup.validate.previous": "kembali",
        "user.quick_signup.validate.send.sms": "Hantar kod pengesahan",
        "user.quick_signup.validate.submit": "Selesaikan Pendaftaran",
        "user.quick_signup.validate.success": "Terima kasih kerana menyertai kami sebagai ahli! <br/> Anda boleh melengkapkan proses pendaftaran, <br/>atau ",
        "user.quick_signup.validate.success.shop": "pergi membeli-belah sekarang",
        "user.quick_signup.validate.title": "Teruskan dengan Mendaftar",
        "user.quick_signup.validate.wrong.number": "Sekiranya nombor telefon bimbit tidak betul, sila",
        "user.sign_up.check_phone.error": "This is same as current mobile phone.<br>Please change another phone if you want to update it.",
        "user.sign_up.email_verification.dialog.confirm": "Sahkan",
        "user.sign_up.email_verification.dialog.description": "Sila sahkan e-mel sekarang dan alamat e-mel baharu akan dikemas kini. Jika anda tidak menerimanya, sila masukkan e-mel anda sekali lagi dan simpan.",
        "user.sign_up.email_verification.dialog.title": "E-mel pengesahan dihantar kepada {{mail}}",
        "user_credit": "store credits",
        "user_reminder.coupon.action": "Claim now",
        "user_reminder.coupon.guest": "Please login to claim coupons.",
        "user_reminder.coupon.member": "There are unclaimed coupons. Please proceed and claim them!",
        "user_reminder.coupon.v2.desktop": "Your exclusive coupons",
        "user_reminder.coupon.v2.mobile": "Exclusive coupons for you. Claim now!",
        "user_reminder.member_referral.action": "Sign up now",
        "user_reminder.member_referral.member_point": "Sign up to earn {{ value }} member points",
        "user_reminder.member_referral.user_credit": "Sign up to earn {{ value }} store credits",
        "users.add.delivery_address": "Tambah alamat baharu",
        "users.add.delivery_address.maximum": "Anda hanya boleh menambah sehingga 5 alamat.",
        "users.add.phone": "Tambah nombor baharu",
        "users.add.phone.maximum": "Anda hanya boleh menambah sehingga 5 nombor telefon.",
        "users.birthday.faq": "You should over certain age to register and shop at the online store.",
        "users.edit_member_info": "Edit Member Profile",
        "users.einvoice_carrier": "Jumlahkan E-invois ke dalam akaun anda",
        "users.error.maxlength": " terlalu panjang.",
        "users.error.no_changes": "Tiada perubahan untuk disimpan.",
        "users.error.not_save_mobile_phone": "Please verify this phone number before saving change.",
        "users.error.phone.format": "Nombor Telefon tidak sah",
        "users.error.phone.required": "Nombor Telefon diperlukan",
        "users.fields.callingCode": "Calling Code",
        "users.fields.callingCodeHint": "Please select country calling code",
        "users.fields.email": "E-mel",
        "users.fields.email.placeholder": "E-mel",
        "users.fields.mobile": "Mobile number",
        "users.fields.mobile.placeholder": "Mobile number",
        "users.fields.mobile_phone_or_email": "E-mel atau nombor telefon bimbit",
        "users.fields.name": "Nama Penuh",
        "users.fields.name.placeholder": "Nama Penuh",
        "users.fields.password": "Kata Laluan",
        "users.fields.password.placeholder": "Kata Laluan",
        "users.member.normal-level": "Basic",
        "users.membership.all.spending_single_purchase": "Single purchase over {{spending}}.",
        "users.membership.all.spending_within_months": "Total purchase over {{spending}} within {{months}} month(s).",
        "users.membership.all_tiers": "View All Membership",
        "users.membership.all_tiers.condition": "Membership",
        "users.membership.all_tiers.description": "Membership will downgrade on expiry date if extension condition is not meet.",
        "users.membership.expire.month_valid": "（Valid Period {{months}} Month(s))",
        "users.membership.expire.unlimited": "Never Expire",
        "users.membership.expiry_date": "Membership Expiry Date",
        "users.membership.extend_valid_period": "{{ type === \"within_interval\" ? \"Total\" : \"Single\" }} purchase over {{spending}} within membership valid period {{months}} months.",
        "users.membership.extension.condition": "Extension Condition",
        "users.membership.extension.status": "Membership Extend Status",
        "users.membership.forget_password.email_sent": "We have sent an email to {{email}}. Open the email and reset your password.",
        "users.membership.max_level_tier": "Congrats! You are in TOP membership level.",
        "users.membership.member_info.birthday": "Birthday",
        "users.membership.member_info.coupons": "{{count}} coupons",
        "users.membership.member_info.email": "Email",
        "users.membership.member_info.gender": "Gender",
        "users.membership.member_info.hint": "Fill in the following member information: {{fields}}, you can get {{rewards}} after filling the profile information",
        "users.membership.member_info.member_points": "{{count}} member points",
        "users.membership.member_info.mobile": "Mobile number",
        "users.membership.member_info.name": "Name",
        "users.membership.member_info.sent": "After the information check is completed, Member Profile Completion Reward will be issued!",
        "users.membership.member_info.symbol": ", ",
        "users.membership.member_info.title": "Member Profile Completion Reward",
        "users.membership.member_info.user_credits": "${{count}} store credits",
        "users.membership.offer.discount": "Membership Offer",
        "users.membership.spending_single_purchase": "Upgrade with single purchase over {{spending}}.",
        "users.membership.spending_within_months": "Upgrade with total purchase over {{spending}} within {{months}} month(s).",
        "users.membership.tier.expire.date": "Valid Period :",
        "users.membership.tier.expire.date.auto_downgrade.description": "Upgrade condition will be checked during midnight. Membership upgrade will not be effective if order has been cancelled/refunded.",
        "users.membership.tier.expire.date.description": "Upgrade condition will be checked during midnight. Membership upgrade will not be effective if order has been cancelled/refunded.",
        "users.membership.tier.expire.month": "{{month}} Month(s)",
        "users.membership.tier.extend": "Eligible to extend <b>{{tier}}</b>?",
        "users.membership.tier.extend.condition": " Extension Condition :",
        "users.membership.tier.extend.single_purchase": "No single purchase over {{dollar}} within {{month}}-month membership valid period.",
        "users.membership.tier.extend.single_purchase.can_extend": "You have a single purchase over {{dollar}} within {{month}}-month membership valid period. Membership extension will be effective on expiry date.",
        "users.membership.tier.extend.top_level.single_purchase": "No single purchase over {{dollar}} within {{month}}-month membership valid period.",
        "users.membership.tier.extend.top_level.single_purchase.can_extend": "You have a single purchase over {{dollar}} within membership valid period. Congrats! Membership extension will be effective on expiry date.",
        "users.membership.tier.extend.top_level.within_interval": "{{dollar}} more to extend",
        "users.membership.tier.extend.top_level.within_interval.can_extend": "Congrats! Extension will be effective on expiry date.",
        "users.membership.tier.extend.within_interval": "Your total purchase within {{month}}-month membership valid period is {{spending}}. {{dollar}} more to extend.",
        "users.membership.tier.extend.within_interval.can_extend": "Your total purchase within {{month}}-month membership valid period is over {{dollar}}. Extension will be effective on expiry date.",
        "users.membership.tier.extension.date.description": "Membership extension will not be effective if order has been cancelled/refunded.",
        "users.membership.tier.shopping_discount": "Member offer {{discount}}% off",
        "users.membership.tier.upgrade.completed": "Eligible to upgrade.",
        "users.membership.tier.upgrade.condition": "Upgrade Condition of this level :",
        "users.membership.tier.upgrade.condition.continue": "Continue Shopping!",
        "users.membership.tier.upgrade.condition.dollar": "No single purchase over {{dollar}} currently.",
        "users.membership.tier.upgrade.gap_dollar": "{{dollar}} more to upgrade",
        "users.membership.tier.upgrade.to_next_level.single": "Upgrade to next level ?",
        "users.membership.tier.upgrade.to_next_level.within": "Total purchase within {{month}} month(s) ",
        "users.membership.upgrade.next_tier": "Upgrade to {{tier_name}}",
        "users.membership.upgrade.next_tier.discount": ", get {{discount}}% off",
        "users.phone.migrate.notification": "To update shop functions, only one of customer’s phone number will be kept from 2019/1/15 onwards. If you have saved more than one phone number, please confirm the latest one is correct.",
        "users.save.email_verification.send": "Verification Email Sent",
        "users.save.email_verification.success": "Perubahan sudah disimpan. Alamat e-mel akan dikemas kini selepas pengesahan selesai.",
        "users.save.success": "Perubahan sudah disimpan.",
        "users.signin.error.invalid.email": "Invalid email or password.",
        "users.signin.error.invalid.mobile": "Invalid mobile number or password.",
        "users.signup.email": "Mendaftar melalui E-mel",
        "users.signup.female": "Perempuan",
        "users.signup.male": "Lelaki",
        "users.signup.mobile_phone": "Mendaftar melalui nombor telefon bimbit",
        "users.signup.other": "Tidak diberitahu",
        "users.signup.unconfirmed": "Selamat Kembali! Untuk melindungi akaun anda, pengesahan diperlukan untuk daftar masuk ke akaun anda. E-mel pengesahan sudah dihantar ke {{email}}. Sila semak peti surat anda. Terima kasih!",
        "users.signup.verification.hint.send": "E-mel pengesahan dihantar. Anda boleh menghantar semula e-mel baharu selepas {{count}} saat.",
        "verification.email.trial_merchant.reach_limit.failure": "The verification email is not available during the trial operation of the store. If needed, please contact the store for assistance.",
        "view_my_coupons": "View my coupons",
        "whatsapp_messenger_checkbox.subscribe": "Send via WhatsApp",
        "wishlist.messages.remove_error": "Tidak dapat mengeluarkan item senarai idaman.",
        "wishlist.signin_register": "Daftar Sekarang",
        "zeek.pickup.area": "Self pickup district",
        "zeek.pickup.region": "Self pickup region",
        "zeek.station.address": "Self pickup address",
        "zeek.station.name": "Self pickup location name",
        "zeek.station.provider": "Self pickup service provider"
      });
    $translateProvider.preferredLanguage("ms");
  },
]);
